import {
    AixAction,
    ErrorWrapper,
    SendBundlePayload,
    SendBundleResponse,
    type
} from '@trade-platform/ui-shared';

export class OrderSendBundleActionTypes {
    static readonly ORDER_SEND_BUNDLE = type('[Order Send Bundle] Order Send Bundle');
    static readonly ORDER_SEND_BUNDLE_SUCCESS = type(
        '[Order Send Bundle] Order Send Bundle Success'
    );
    static readonly ORDER_SEND_BUNDLE_FAILURE = type(
        '[Order Send Bundle] Order Send Bundle Failure'
    );
    static readonly ORDER_SEND_BUNDLE_RESET = type('[Order Send Bundle] Order Send Bundle Reset');
}

export type OrderSendBundleActions =
    | OrderSendBundle
    | OrderSendBundleSuccess
    | OrderSendBundleFailure
    | OrderSendBundleReset;

export class OrderSendBundle implements AixAction {
    readonly type = OrderSendBundleActionTypes.ORDER_SEND_BUNDLE;

    constructor(public payload: SendBundlePayload) {}
}

export class OrderSendBundleSuccess implements AixAction {
    readonly type = OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_SUCCESS;

    constructor(public payload: SendBundleResponse) {}
}

export class OrderSendBundleFailure implements AixAction {
    readonly type = OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_FAILURE;

    constructor(public payload: { error: ErrorWrapper }) {}
}

export class OrderSendBundleReset implements AixAction {
    readonly type = OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_RESET;
}
